import { type PrimaryProductKey, ProductKeys } from '../product-keys';
import type { FilterId } from './index';

type InlineFilterIds = [] | [FilterId] | [FilterId, FilterId];

// Anything unmapped (Home, other 1P apps, every connector) gets no inline filters.
const INLINE_FILTER_IDS_BY_PRODUCT: Partial<Record<ProductKeys, InlineFilterIds>> = {
	[ProductKeys.Confluence]: ['space'],
	[ProductKeys.Jira]: ['project'],
};

// Placement only — callers must intersect with the visible set from getExcludedFilterIds.
// With no app selected ("All apps"), the primary product's own set applies.
export const inlineFilterIdsFor = (
	selectedProduct: ProductKeys | undefined,
	primaryProduct?: PrimaryProductKey,
): FilterId[] => {
	const product = selectedProduct ?? primaryProduct;
	if (!product) {
		return [];
	}

	return INLINE_FILTER_IDS_BY_PRODUCT[product as ProductKeys] ?? [];
};
